<template>
	<span class="check-icon-toggle" :class="{'disabled': disabled}" @click="onClick()">
		<check-icon-outlined class="assign" color="primary" v-if="!checked" :disabled="disabled" />
		<check-icon-filled class="assign" color="primary" v-if="checked" :disabled="disabled"/>
	</span>
</template>

<script>
import CheckIconOutlined from '@/modules/shared/components/icons/check-icon-outlined';
import CheckIconFilled from '@/modules/shared/components/icons/check-icon-filled';

export default {
	name: 'check-icon-toggle',
	components: { CheckIconFilled, CheckIconOutlined },
	props: ['checked', 'disabled'],
	methods: {
		onClick() {
			if (this.disabled) return;
			this.$emit('click');
		},
	},
};
</script>

<style lang="scss" scoped>
.check-icon-toggle {
	cursor: pointer;
	&.disabled {
		cursor: not-allowed;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/check-icon-toggle.vue